import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const USER_CATEGORY_KEY = 'USER_CATEGORY';
export const USER_GUIDE_DONE_KEY = 'USER_GUIDE_DONE';

export type UserCategory = 'homebuyer' | 'realtor' | 'business' | 'researcher' | 'healthcare' | 'other' | 'unspecified';

import { SubscriptionPlans } from '../../user/user/user.model';

// String literals used intentionally to avoid circular-dependency init-order issues
export const CATEGORY_TO_PLAN: Partial<Record<UserCategory, SubscriptionPlans>> = {
  homebuyer:  'HOME_SEARCH'    as SubscriptionPlans,
  realtor:    'REAL_ESTATE'    as SubscriptionPlans,
  business:   'SITE_SELECTION' as SubscriptionPlans,
  researcher: 'RESEARCH'       as SubscriptionPlans,
};

// Configurable — change to highlight a different layer in the guide
export const GUIDE_HIGHLIGHT_FEATURE = 'MEDIAN_HOUSEHOLD_INCOME_TREND';

// Configurable — minimum zoom level to complete the zoom task
export const GUIDE_MIN_ZOOM = 7;

// Configurable — promo code shown after completing all guide tasks
export const GUIDE_PROMO_CODE = 'BESTLOCATION';

export const PROMO_CODE_DISMISSED_KEY = 'PROMO_CODE_DISMISSED';

@Injectable({ providedIn: 'root' })
export class UserGuideService {
  // Emits the featureConst key that should receive the purple highlight in the menu.
  // null = no highlight active.
  readonly highlightFeature$ = new BehaviorSubject<string | null>(null);

  // Pulses true briefly when the user clicks the layer row in the guide checklist
  // without having explored the layer yet — triggers a stronger visual in the right panel.
  readonly highlightPulse$ = new BehaviorSubject<boolean>(false);
}
